import React, { ChangeEvent } from 'react';
import { styled } from '@mui/material';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { METRICS_OPTIONS } from 'dashboard409a/common/constants/components/metrics';

const PREFIX = 'MetricDropdown';

const classes = {
  dropdownTitle: `${PREFIX}-dropdownTitle`,
  dropdown: `${PREFIX}-dropdown`,
};

const StyledGrid = styled(Grid)(() => ({
  [`& .${classes.dropdownTitle}`]: {
    marginRight: 15,
    fontSize: 14,
  },

  [`& .${classes.dropdown}`]: {
    fontSize: 14,
    '& .MuiOutlinedInput-input': {
      padding: 14,
      paddingRight: 35,
    },
  },
}));

type MetricDropdownProps = {
  value: string;
  title: string;
  handleChange: (event: ChangeEvent<{ value: unknown }>) => void;
  options?: string[];
};

const MetricDropdown = ({ value, title = 'Metric', handleChange, options = METRICS_OPTIONS }: MetricDropdownProps) => (
  <StyledGrid container justifyContent="flex-start" alignItems="center" direction="row">
    <Typography className={classes.dropdownTitle}>{title}</Typography>
    <FormControl>
      <Select value={value} onChange={handleChange} displayEmpty variant="outlined" className={classes.dropdown}>
        {options.map((metric, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <MenuItem key={`metric-${index}`} value={metric}>
            {metric}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </StyledGrid>
);

export default MetricDropdown;
